import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';
const handleQuery = (style) => {
  return `
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};
  `;
};
/*export const Container = styled.div`
  img {
    width: 100%;
  }
`;*/

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    width: 60%;
  }
  ${handleQuery(css`
    img {
      width: 50%;
    }
  `)}
`;

export const ContaineText = styled.div`
  margin: 0 auto;
  p {
    font-family: 'Inter', sans-serif;
    color: #0000c9;
    font-weight: 400;
    font-size: clamp(16px, 4vw, 58px);
    line-height: 70px;
    strong {
      font-weight: bold;
    }
  }
  @media (max-width: 1024px) {
    p {
      line-height: 40px;
    }
  }

  @media (max-width: 500px) {
    p {
      line-height: 30px;
    }
  }
`;

export const ButtonGrow = styled.button`
  font-family: 'Inter', sans-serif;
  background-color: #0000c9;
  color: #fff;
  border-radius: 100px;
  font-weight: bold;

  padding: 1em 2em;
  border: none;
  cursor: pointer;
  margin-top: 1em;

  ${handleQuery(css`
    padding: 1em 0;

    width: 145px;
    font-size: 11px;
  `)}
`;
